<template>
  <div class="outlet page">
    <div class="page-title">
      <span>{{$t('revenue_report')}}</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{
            getStoreConfig().currency }}</option>
          <option v-for="rate in (getCurrencyRates)" :value="rate.toCurrency" :key="rate.id">
            {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet"
      @onChangeOrderStatus="onChangeOrderStatus" />
    <UiReportList :reportList="reportList" />
    <UiChart v-if="!loading && (report && report.items && typeof (report.items) === 'object')"
      :series="prepareChartSeries(report)" :options="prepareChartOptions(report)" />
    <UiTableReportCommon :report="report" :colsData="colsData" :key="tableKey" />
  </div>
</template>

<script>
import * as _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiChart from '@/components/UiChart'
import UiReportList from '@/components/UiReportList'
import UiTableReportCommon from '@/components/UiTableReportCommon'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
import i18n from '@/i18n'
export default {
  name: 'SellerPage',
  components: {
    UiFilterbar,
    UiChart,
    UiReportList,
    UiTableReportCommon
  },
  data() {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 100,
        mode: 'DATE',
        outletIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      reportList: reportListData.revenue,
      filterType: 'DATE',
      colsData: [],
      tableKey: 0
    }
  },
  watch: {
    cols: function (newData, oldData) {
      if (newData !== oldData) {
        this.colsData = [...newData]
      }
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      cols: 'report/getColsData',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates'
    })
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      getCustomStatuses: 'order/getListCustomStatus'
    }),
    selectCurrency() {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }

      this.getReport({
        type: reportType.salesman,
        query: {
          ...this.query,
          ...this.day
        }
      }).then(() => {
        this.colsData = this.cols
        this.tableKey = Math.random()
      })
    },
    getStoreConfig() {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onDefaultFilter(day, type, reportingMode, outletIds, registerIds, states) {
      this.day = day
      this.getCustomStatuses()
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.salesman,
        query: {
          ...this.query,
          ...day,
          states
        }
      }).then(() => {
        this.colsData = [...this.cols]
        this.tableKey = Math.random()
      })
    },
    onChangeOutlet(reportingMode, outletIds, registerIds, day, type, states) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.salesman,
        query: {
          ...this.query,
          ...day,
          states
        }
      }).then(() => {
        this.colsData = this.cols
        this.tableKey = Math.random()
      })
    },
    onChangeOrderStatus(reportingMode, outletIds, registerIds, day, type, states) {
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.salesman,
        query: {
          ...this.query,
          ...day,
          states
        }
      })
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.salesman,
        query: {
          ...this.query,
          ...day,
          states,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    prepareDataToViewOnTable() {
      const list = {
        title: {},
        items: {}
      }

      this.report.forEach(item => {
        list.title[item.salesman] = item.salesman

        if (list.items[item.salesman] === undefined) {
          list.items[item.salesman] = {}
        }

        list.items[item.salesman][item.createdAt] = item.totalPrice
      })

      return list
    },
    prepareColsToViewOnTable() {
      const cols = {}

      this.report.forEach(item => {
        cols[item.createdAt] = true
      })

      return cols
    },
    formartDate(date) {
      if (!_.isDate(new Date(date).toString())) return date
      return i18n.d(new Date(moment(date).toDate().toUTCString()), 'short')
    },
    formatTotal(total) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(currentCurrent?.rate || '1')).toFixed(2), { maxFraction: 2 })}`
    },
    prepareChartOptions(reports) {
      const dateList = reports && reports.items ? Object.keys(reports.items).map(item => this.formartDate(item)) : []

      return {
        chart: {
          id: 'product-sold-chart',
          type: 'line',
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        stroke: {
          width: 2
        },
        colors: ['#F3B415', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8', '#A9D794',
          '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
        ],
        markers: {
          size: 4,
          hover: {
            size: 7,
            sizeOffset: 3
          }
        },
        noData: {
          text: i18n.t('no_data')
        },
        xaxis: {
          categories: dateList
        },
        yaxis: {
          labels: {
            formatter: value => { return this.formatTotal(value) }
          }
        }
      }
    },
    prepareChartSeries(reports) {
      let paymentList = []
      if (reports && reports.items) {
        Object.keys(reports.items).map(item => {
          paymentList = _.union(paymentList, Object.keys(reports.items[item]))
        })
      }

      const dataList = []
      paymentList.forEach(payment => {
        const paymentData = {
          name: payment,
          data: []
        }
        Object.keys(reports.items).forEach(item => {
          paymentData.data.push(reports.items[item][payment] ? parseFloat(reports.items[item][payment]).toFixed(6) : 0)
        })
        dataList.push(paymentData)
      })

      return dataList
    },
    isNotUseStoreCurrency(currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    }
  },
  created() {
    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 0 30px;
}

.page-title {
  font-size: 36px;
  line-height: 49px;
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;

  select {
    padding: 0 15px;
    margin: 0;
    height: 39px;
    min-width: 140px;
    outline: none;
    border-radius: 4px;
    border: 1px solid #818181;
    background-color: #fff;
  }
}
</style>
